import type { ThemeColorName } from '@examdojo/styles';
import type { ArrowRouting } from '@examdojo/core/widget';

// =============================================================================
// TYPES
// =============================================================================

export interface ArrowAnnotationElement {
  type: 'ArrowAnnotation';
  params: {
    /** Port ref to target point/midpoint */
    target: string;
    /** Label text to display */
    label: string;
    /** Offset from target in [dx, dy] units */
    offset?: [number, number];
    /** Arrow routing mode */
    routing?: ArrowRouting;
  };
  color?: ThemeColorName;
}

// =============================================================================
// DEFAULTS
// =============================================================================

export const ARROW_ANNOTATION_DEFAULTS = {
  offset: [2, 2] as [number, number],
  color: 'neutral' as ThemeColorName,
  routing: 'straight' as ArrowRouting,
} as const;
